/* ギフト特集のレイアウト（templates/article.smart-gift.json で表示する記事）— 2026-10-15
 *
 * 本文はアプリ（Smart Agent Blog）で編集できるよう、見出し・文章・画像・リンク・箇条書き・太字だけで保存する。
 * 表示するときに、決まった書き方を読み取って元の記事 gift-2 と同じクラスの作りに組み直す（見た目は assets/kinujo-article-gift.css、
 * タブ・開閉・拡大表示の動きは assets/kinujo-article-widgets.js）。
 *
 * 書き方（本文の上から順に）
 *   ・最初の見出し2より前：そのまま表示（アイキャッチ画像・注意書きなど）
 *   ・セクション：見出し2（日本語）＋ 直後の段落を太字だけで（英語）→ セクション見出し。上部のページ内リンクは自動で作る
 *   ・商品紹介：段落「ITEM 01 /DRYER」＋ 見出し3（商品名）＋ 段落「カラー・種類：A／B」（任意）＋ 説明の段落 ＋ 画像
 *       → 説明と画像の横並び。続く 見出し4「POINT 1　題」＋ 画像 ＋ 段落（＋ 小さい文字の段落＝注記）→ POINT のカード
 *   ・予算：見出し3「タブ名｜バッジ｜見出し」（バッジ省略可）＋ 段落（リード文）＋ 見出し4（商品名）＋ 画像 ＋ 段落 ＋ リンクだけの段落
 *   ・選ばれる理由：見出し3「POINT 01　見出し」＋ 画像 ＋ 段落
 *       画像 ＋ 段落「紹介アイテム：リンク／リンク」→ 拡大表示できるギャラリー
 *       太字だけの段落「英語｜日本語」＋ 画像 ＋ 段落 → グループ見出し。続く 見出し4 ＋ 画像 ＋ 段落（＋「※」で始まる段落＝注記）→ 開閉
 *   ・ラッピング：画像 ＋ 箇条書き（特典）＋ 見出し3（注意書きの題）＋ 箇条書き
 *   ・「ご購入はこちら」だけのリンクの段落（予算の商品以外）→ 元の記事と同じボタン画像（幅400px・中央）
 * 書き方に合わない部分は、組み直さずにそのまま表示する
 * アプリで保存すると、画像の前に空の段落が入る・画像が段落の外に出る・小さい文字（small）が消える（2026-10-15 実測）
 *   → 空の段落は読み飛ばし、画像は段落の内外どちらでも読む。注記は「※」で始まる段落で見分ける
 */
(function () {
  var CTA_IMG = 'https://cdn.shopify.com/s/files/1/0721/9396/6159/files/cta-1.png?v=1788018222';
  var ICONS = {"送料無料": "<svg viewbox=\"0 0 24 24\"><rect height=\"10\" width=\"13\" x=\"1\" y=\"6\"></rect><path d=\"M14 9h4l4 4v3h-8z\"></path><circle cx=\"6\" cy=\"18\" r=\"2\"></circle><circle cx=\"17.5\" cy=\"18\" r=\"2\"></circle></svg>", "ギフトラッピング無料": "<svg viewbox=\"0 0 24 24\"><rect height=\"12\" width=\"20\" x=\"2\" y=\"9\"></rect><path d=\"M2 9h20v4H2z\"></path><path d=\"M12 9v12\"></path><path d=\"M12 9c-1.5-4-6-5-6-2 0 1.5 2 2 6 2z\"></path><path d=\"M12 9c1.5-4 6-5 6-2 0 1.5-2 2-6 2z\"></path></svg>", "メーカー保証1年": "<svg viewbox=\"0 0 24 24\"><path d=\"M12 2l8 3v6c0 5-3.5 8.5-8 11-4.5-2.5-8-6-8-11V5z\"></path><path d=\"M8.5 12l2.5 2.5L16 9\"></path></svg>"};

  function txt(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function tag(el) { return el.tagName.toLowerCase(); }
  function imgOf(el) {
    if (!el) return null;
    if (tag(el) === 'img') return el;
    var imgs = el.querySelectorAll('img');
    return imgs.length === 1 && !txt(el) ? imgs[0] : null;
  }
  function isP(el) { return el && tag(el) === 'p'; }
  function boldOnly(el) {
    if (!isP(el) || imgOf(el)) return false;
    var s = el.querySelector('strong, b');
    return !!s && txt(s) === txt(el) && txt(el) !== '';
  }
  function smallOnly(el) { var s = isP(el) && el.querySelector('small'); return !!s && txt(s) === txt(el); }
  // 開閉の注記：小さい文字の段落、または「※」で始まる段落（アプリで保存すると small が消えるため）
  function noteLike(el) { return smallOnly(el) || (isP(el) && !imgOf(el) && /^※/.test(txt(el))); }
  function linkOnly(el) { var a = isP(el) && el.querySelector('a'); return !!a && txt(a) === txt(el); }
  function h(name, cls, html) {
    var e = document.createElement(name);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function imgEl(src, cls, alt) {
    var i = document.createElement('img');
    i.src = src.getAttribute('src'); i.alt = alt != null ? alt : (src.getAttribute('alt') || '');
    i.loading = 'lazy'; i.decoding = 'async';
    if (cls) i.className = cls;
    return i;
  }

  // 商品紹介（ITEM）のセクション
  function buildRecommend(nodes, frag) {
    var items = [], cur = null;
    nodes.forEach(function (n) {
      if (isP(n) && /^ITEM\s*\d+/i.test(txt(n))) { cur = { kicker: txt(n), rest: [] }; items.push(cur); return; }
      if (cur) cur.rest.push(n); else frag.appendChild(n);
    });
    var nav = h('nav', 'kj-recommend-nav');
    frag.appendChild(nav);
    items.forEach(function (it, idx) {
      var id = 'kj-item' + ('0' + (idx + 1)).slice(-2);
      if (idx) frag.appendChild(h('hr', 'kj-item-divider'));
      var r = it.rest, i = 0;
      var title = r[i] && tag(r[i]) === 'h3' ? txt(r[i++]) : '';
      var a = h('a', null); a.href = '#' + id; a.textContent = title; nav.appendChild(a);
      var tags = [];
      if (isP(r[i]) && /^カラー・種類：/.test(txt(r[i]))) tags = txt(r[i++]).replace(/^カラー・種類：/, '').split('／');
      var descs = [];
      while (i < r.length && isP(r[i]) && !imgOf(r[i])) descs.push(r[i++]);
      var main = imgOf(r[i]) ? imgOf(r[i++]) : null;
      var mt = h('div', 'wp-block-media-text has-media-on-the-right is-stacked-on-mobile is-vertically-aligned-top');
      var ct = h('div', 'wp-block-media-text__content');
      var blk = h('div', 'kj-item-block'); blk.id = id;
      blk.appendChild(h('p', 'kj-item-kicker')).textContent = it.kicker;
      var t3 = h('h3', 'kj-item-title'); t3.appendChild(h('strong')).textContent = title; blk.appendChild(t3);
      ct.appendChild(blk);
      if (tags.length) {
        var tg = h('div', 'kj-item-tags');
        tags.forEach(function (t) { tg.appendChild(h('span', 'kj-item-tag')).textContent = t; });
        ct.appendChild(tg);
      }
      descs.forEach(function (d) { d.classList.add('wp-block-paragraph'); ct.appendChild(d); });
      mt.appendChild(ct);
      if (main) { var fg = h('figure', 'wp-block-media-text__media'); fg.appendChild(imgEl(main)); mt.appendChild(fg); }
      frag.appendChild(mt);
      var row = null;
      while (i < r.length) {
        var n = r[i];
        if (tag(n) === 'h4' && /^POINT/i.test(txt(n))) {
          var m = txt(n).match(/^(POINT\s*\d+)\s*(.*)$/i) || [null, txt(n), ''];
          var pt = h('div', 'kj-point');
          pt.appendChild(h('span', 'kj-point-badge')).textContent = m[1];
          i++;
          if (imgOf(r[i])) pt.appendChild(imgEl(imgOf(r[i++]), 'kj-point-img'));
          pt.appendChild(h('p', 'kj-point-title')).textContent = m[2];
          if (isP(r[i]) && !imgOf(r[i]) && !smallOnly(r[i])) { var dsc = h('p', 'kj-point-desc'); dsc.innerHTML = r[i++].innerHTML; pt.appendChild(dsc); }
          if (smallOnly(r[i])) { pt.appendChild(h('p', 'kj-point-note')).textContent = txt(r[i++]); }
          if (!row) { row = h('div', 'kj-point-row'); frag.appendChild(row); }
          row.appendChild(pt);
          continue;
        }
        row = null;
        frag.appendChild(n); i++;
      }
    });
  }

  // 予算（タブ）のセクション
  function buildPrice(nodes, frag) {
    var panels = [], cur = null;
    nodes.forEach(function (n) {
      if (tag(n) === 'h3' && txt(n).indexOf('｜') > -1) { cur = { head: txt(n).split('｜'), rest: [] }; panels.push(cur); return; }
      if (cur) cur.rest.push(n); else frag.appendChild(n);
    });
    var tabs = h('div', 'kj-pt-nav');
    frag.appendChild(tabs);
    panels.forEach(function (p, idx) {
      var id = 'pt' + (idx + 1);
      var tab = p.head[0], badge = p.head.length > 2 ? p.head[1] : p.head[0], copy = p.head[p.head.length - 1];
      var b = h('button', 'kj-pt-tab' + (idx === 0 ? ' active' : '')); b.type = 'button'; b.dataset.tab = id; b.textContent = tab;
      tabs.appendChild(b);
      var pn = h('div', 'kj-pt-panel' + (idx === 0 ? ' active' : '')); pn.id = id;
      var hd = h('div'); hd.appendChild(h('span', 'kj-pt-badge')).textContent = badge; hd.appendChild(h('h2', 'kj-pt-copy')).textContent = copy;
      pn.appendChild(hd);
      var r = p.rest, i = 0, row = null;
      while (i < r.length && tag(r[i]) !== 'h4') { var n0 = r[i++]; if (isP(n0) && !imgOf(n0)) n0.className = 'kj-pt-lead'; pn.appendChild(n0); }
      while (i < r.length) {
        if (tag(r[i]) !== 'h4') { pn.appendChild(r[i++]); continue; }
        var card = h('div', 'kj-pt-card');
        var name = txt(r[i++]);
        if (imgOf(r[i])) card.appendChild(imgEl(imgOf(r[i++]), 'kj-pt-img'));
        card.appendChild(h('p', 'kj-pt-name')).textContent = name;
        while (i < r.length && isP(r[i]) && !imgOf(r[i])) {
          var q = r[i++];
          if (linkOnly(q)) { var a = q.querySelector('a'); a.className = 'kj-pt-btn'; var pp = h('p'); pp.appendChild(a); card.appendChild(pp); }
          else { q.className = 'kj-pt-desc2'; card.appendChild(q); }
        }
        if (!row) { row = h('div', 'kj-pt-row'); pn.appendChild(row); }
        row.appendChild(card);
      }
      frag.appendChild(pn);
    });
  }

  // 選ばれる理由のセクション
  function buildWhy(nodes, frag) {
    var blocks = [], cur = null;
    nodes.forEach(function (n) {
      if (tag(n) === 'h3' && /^POINT/i.test(txt(n))) { cur = { head: txt(n), rest: [] }; blocks.push(cur); return; }
      if (cur) cur.rest.push(n); else frag.appendChild(n);
    });
    var wrap = h('div', 'kj-why-blocks');
    frag.appendChild(wrap);
    blocks.forEach(function (bk, idx) {
      if (idx) wrap.appendChild(h('hr', 'kj-why-divider'));
      var el = h('div', 'kj-why-block' + (idx % 2 ? ' kj-why-block-rev' : ''));
      var m = bk.head.match(/^(POINT\s*\d+)\s*(.*)$/i) || [null, '', bk.head];
      var r = bk.rest, i = 0;
      if (imgOf(r[i])) { var vis = h('div', 'kj-why-visual'); vis.appendChild(imgEl(imgOf(r[i++]), null, m[2])); el.appendChild(vis); }
      var ct = h('div', 'kj-why-content');
      ct.appendChild(h('span', 'kj-why-badge')).textContent = m[1];
      ct.appendChild(h('h3', 'kj-why-heading')).textContent = m[2];
      if (isP(r[i]) && !imgOf(r[i]) && !boldOnly(r[i])) { var tx = h('p', 'kj-why-text'); tx.innerHTML = r[i++].innerHTML; ct.appendChild(tx); }
      el.appendChild(ct);
      var gal = null, group = null, list = null, n = 0;
      while (i < r.length) {
        var nd = r[i];
        // ギャラリー：画像 ＋「紹介アイテム：」
        if (imgOf(nd) && isP(r[i + 1]) && /^紹介アイテム：/.test(txt(r[i + 1]))) {
          if (!gal) { gal = h('div', 'kj-why-gallery'); el.appendChild(gal); }
          var prods = Array.prototype.map.call(r[i + 1].querySelectorAll('a'), function (a) { return { name: txt(a), url: a.getAttribute('href') }; });
          var sp = h('span'); sp.setAttribute('data-products', JSON.stringify(prods));
          sp.appendChild(imgEl(imgOf(nd), null, 'UGC' + (++n)));
          gal.appendChild(sp);
          i += 2;
          if (!(imgOf(r[i]) && isP(r[i + 1]) && /^紹介アイテム：/.test(txt(r[i + 1])))) {
            var bar = h('div', 'kj-why-gallery-bar'); bar.appendChild(h('div', 'kj-why-gallery-bar-thumb')); el.appendChild(bar);
            var hint = h('p'); hint.textContent = 'タップすると拡大します'; hint.style.cssText = 'font-size:11px;color:#B3A692;margin:-12px 0 0;'; el.appendChild(hint);
            gal = null;
          }
          continue;
        }
        // グループ見出し：太字だけの段落「英語｜日本語」
        if (boldOnly(nd) && txt(nd).indexOf('｜') > -1) {
          var parts = txt(nd).split('｜');
          group = h('div', 'kj-why-group');
          var head = h('div', 'kj-why-group-head');
          i++;
          var th = h('span', 'kj-why-group-thumb');
          if (imgOf(r[i])) th.appendChild(imgEl(imgOf(r[i++])));
          head.appendChild(th);
          var dv = h('div');
          if (parts[0].indexOf('/') > -1) { dv.appendChild(h('span', 'kj-why-group-kicker')).textContent = parts[0]; dv.appendChild(h('span', 'kj-why-group-title-lg')).textContent = parts[1]; }
          else { dv.appendChild(h('span', 'kj-why-group-en')).textContent = parts[0]; dv.appendChild(h('span', 'kj-why-group-ja')).textContent = parts[1]; }
          if (isP(r[i]) && !imgOf(r[i])) { var sb = h('p', 'kj-why-group-sub'); sb.innerHTML = r[i++].innerHTML; dv.appendChild(sb); }
          head.appendChild(dv);
          group.appendChild(head);
          list = h('div', 'kj-why-toggle-list');
          group.appendChild(list);
          el.appendChild(group);
          continue;
        }
        // 開閉：見出し4 ＋ 画像 ＋ 段落（＋ 小さい文字）
        if (tag(nd) === 'h4') {
          var label = txt(nd); i++;
          var tgl = h('div', 'kj-why-toggle');
          var th2 = h('div', 'kj-why-toggle-head');
          th2.appendChild(h('span', 'kj-why-toggle-label')).textContent = label;
          th2.appendChild(h('span', 'kj-why-plus')).textContent = '＋';
          tgl.appendChild(th2);
          var body = h('div', 'kj-why-toggle-body'), inner = h('div', 'kj-why-toggle-body-inner');
          if (imgOf(r[i])) { var ev = h('div', 'kj-why-evidence-img'); ev.appendChild(imgEl(imgOf(r[i++]), null, label)); inner.appendChild(ev); }
          var et = h('div', 'kj-why-evidence-text');
          if (isP(r[i]) && !imgOf(r[i]) && !noteLike(r[i])) et.innerHTML = r[i++].innerHTML;
          if (noteLike(r[i])) et.appendChild(h('span', 'kj-why-note')).textContent = txt(r[i++]);
          inner.appendChild(et); body.appendChild(inner); tgl.appendChild(body);
          if (!list) { list = h('div', 'kj-why-toggle-list'); el.appendChild(list); }
          list.appendChild(tgl);
          continue;
        }
        el.appendChild(nd); i++;
      }
      wrap.appendChild(el);
    });
  }

  // ラッピングのセクション：画像 ＋ 箇条書き（特典）＋ 見出し3 ＋ 箇条書き
  function buildWrap(nodes, frag) {
    var i = 0, r = nodes;
    var img = imgOf(r[i]) ? imgOf(r[i++]) : null;
    var perks = r[i] && tag(r[i]) === 'ul' ? r[i++] : null;
    var title = r[i] && tag(r[i]) === 'h3' ? txt(r[i++]) : '';
    var notes = r[i] && tag(r[i]) === 'ul' ? r[i++] : null;
    if (!img || !title || !notes) { nodes.forEach(function (n) { frag.appendChild(n); }); return; }
    var bk = h('div', 'kj-why-block kj-wrap-block');
    var col = h('div', 'kj-wrap-visual-col');
    var vis = h('div', 'kj-why-visual'); vis.appendChild(imgEl(img)); col.appendChild(vis);
    if (perks) {
      var row = h('div', 'kj-perk-row');
      Array.prototype.forEach.call(perks.querySelectorAll('li'), function (li) {
        var label = txt(li), icon = ICONS[label];
        if (!icon) Object.keys(ICONS).forEach(function (k) { if (!icon && (label.indexOf(k.slice(0, 2)) > -1)) icon = ICONS[k]; });
        var it = h('div', 'kj-perk-item');
        it.appendChild(h('span', 'kj-perk-icon', icon || ICONS['ギフトラッピング無料']));
        it.appendChild(h('span', 'kj-perk-label')).textContent = label;
        row.appendChild(it);
      });
      col.appendChild(row);
    }
    bk.appendChild(col);
    var ct = h('div', 'kj-why-content'), nt = h('div', 'kj-wrap-notice');
    nt.appendChild(h('p', 'kj-wrap-notice-title')).textContent = title;
    nt.appendChild(notes);
    ct.appendChild(nt); bk.appendChild(ct);
    frag.appendChild(bk);
    while (i < r.length) frag.appendChild(r[i++]);
  }

  function build(root) {
    if (!root || root.dataset.kjGift) return;
    root.dataset.kjGift = '1';
    // 空の段落（アプリが画像の前に入れる）は読み飛ばす
    var nodes = Array.prototype.slice.call(root.children).filter(function (n) { return !(isP(n) && !txt(n) && !n.querySelector('img')); });
    var top = [], sections = [], cur = null;
    nodes.forEach(function (n) {
      if (tag(n) === 'h2') { cur = { ja: txt(n), en: '', nodes: [] }; sections.push(cur); return; }
      if (!cur) { top.push(n); return; }
      if (!cur.nodes.length && !cur.en && boldOnly(n)) { cur.en = txt(n); return; }
      cur.nodes.push(n);
    });
    if (!sections.length) return;
    var frag = document.createDocumentFragment();
    top.forEach(function (n) {
      if (imgOf(n)) { var f = h('figure', 'wp-block-image size-large'); f.appendChild(imgEl(imgOf(n))); frag.appendChild(f); }
      else { if (isP(n)) n.classList.add('has-text-align-center', 'wp-block-paragraph'); frag.appendChild(n); }
    });
    var nav = h('nav', 'kj-nav');
    frag.appendChild(nav);
    sections.forEach(function (s, idx) {
      var id = 'sec-' + (idx + 1);
      var a = h('a', 'kj-nav-item'); a.href = '#' + id;
      var t = h('span', 'kj-nav-text');
      // ページ内リンクの英語は先頭の「KINUJO」を省く（元の記事は「KINUJO RECOMMEND」→「RECOMMEND」）
      t.appendChild(h('span', 'kj-nav-en')).textContent = (s.en || s.ja).replace(/^KINUJO\s+/i, '');
      t.appendChild(h('span', 'kj-nav-ja')).textContent = s.ja;
      a.appendChild(t); nav.appendChild(a);
      var h2 = h('h2', 'kj-h2 wp-block-heading has-text-align-center'); h2.id = id; h2.textContent = s.en || s.ja; frag.appendChild(h2);
      if (s.en) frag.appendChild(h('h4', 'kj-h4 wp-block-heading has-text-align-center')).textContent = s.ja;
      var ns = s.nodes;
      var has = function (f) { return ns.some(f); };
      if (has(function (n) { return isP(n) && /^ITEM\s*\d+/i.test(txt(n)); })) buildRecommend(ns, frag);
      else if (has(function (n) { return tag(n) === 'h3' && txt(n).indexOf('｜') > -1; })) buildPrice(ns, frag);
      else if (has(function (n) { return tag(n) === 'h3' && /^POINT/i.test(txt(n)); })) buildWhy(ns, frag);
      else if (has(function (n) { return tag(n) === 'ul'; }) && has(function (n) { return !!imgOf(n); })) buildWrap(ns, frag);
      else ns.forEach(function (n) { frag.appendChild(n); });
    });
    // 「ご購入はこちら」のリンク → ボタン画像（予算のカードの中は文字のボタンのまま）
    Array.prototype.forEach.call(frag.querySelectorAll('p'), function (p) {
      if (!linkOnly(p) || !/^ご購入はこちら/.test(txt(p)) || p.closest('.kj-pt-card')) return;
      var a = p.querySelector('a');
      var fg = h('figure', 'aligncenter size-full is-resized kj-cta');
      var la = h('a'); la.href = a.getAttribute('href');
      var im = document.createElement('img'); im.src = CTA_IMG; im.alt = 'ご購入はこちら'; im.loading = 'lazy'; im.style.cssText = 'width:400px;height:auto';
      la.appendChild(im); fg.appendChild(la);
      p.parentNode.replaceChild(fg, p);
    });
    root.innerHTML = '';
    root.appendChild(frag);
    root.classList.add('kj-gift');
    document.dispatchEvent(new Event('kj:article-open'));
  }

  function init() { build(document.getElementById('smart-blog-article-content')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
